.corevisualization-component {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: flex-start;
}
.corevisualization-component .viz-loading-spinner {
  margin-right: 1.5rem;
}
.corevisualization-component.visualization-fullscreen {
  padding-bottom: 1rem;
  height: calc(100vh - 16rem);
}

.truncateText {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9zcmMvc2NyaXB0L2NvbXBvbmVudHMvVmlzdWFsaXphdGlvbiIsInNvdXJjZXMiOlsiVmlzdWFsaXphdGlvbi5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBOzs7QUFHSjtFQUNFO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5jb3JldmlzdWFsaXphdGlvbi1jb21wb25lbnQge1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWl0ZW1zOiBmbGV4LXN0YXJ0O1xuXG4gIC52aXotbG9hZGluZy1zcGlubmVyIHtcbiAgICBtYXJnaW4tcmlnaHQ6IDEuNXJlbTtcbiAgfVxuXG4gICYudmlzdWFsaXphdGlvbi1mdWxsc2NyZWVuIHtcbiAgICBwYWRkaW5nLWJvdHRvbTogMXJlbTtcbiAgICBoZWlnaHQ6IGNhbGMoMTAwdmggLSAxNnJlbSk7XG4gIH1cbn1cbi50cnVuY2F0ZVRleHQge1xuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbn1cbiJdfQ== */